if (!customElements.get('cart-drawer-rec')) {
  class CartDrawerRec extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.button = this.form.querySelector('[type="submit"]');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onSubmit(event) {
      event.preventDefault();
      if (!this.form) return;
      if (this.button?.getAttribute('aria-disabled') === 'true') return;

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (!cart) return;

      this.button?.setAttribute('aria-disabled', 'true');
      this.button?.classList.add('loading');
      const spinner = this.form.querySelector('.loading__spinner');
      spinner?.classList.remove('hidden');

      const formData = new FormData(this.form);
      formData.append(
        'sections',
        cart.getSectionsToRender().map((s) => s.id).join(',')
      );
      formData.append('sections_url', window.location.pathname);

      const config = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      };

      fetch(window.routes.cart_add_url || '/cart/add', config)
        .then((res) => res.json())
        .then((response) => {
          if (response.status) {
            console.error('Add to cart error:', response.description || response.message);
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-drawer-rec',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          }
          if (cart.classList?.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }
          if (cart.renderContents) {
            cart.renderContents(response);
          }
          if (cart.open) {
            cart.open();
          }
        })
        .catch((err) => {
          console.error('Cart drawer rec add error:', err);
        })
        .finally(() => {
          this.button?.removeAttribute('aria-disabled');
          this.button?.classList.remove('loading');
          spinner?.classList.add('hidden');
        });
    }
  }

  customElements.define('cart-drawer-rec', CartDrawerRec);
}
